<template>
  <div>
    <e-modal modal-id="change-password">
      <div slot="title">Change password for {{ eUser.username }}</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12">
            <input type="password" placeholder="Password" v-model="password['pass']" class="form-control" @keydown.enter="updatePassword">
          </div>
          <div class="col-lg-12 m-t-xs m-b-xs">
            <input type="password" placeholder="Retype Password" v-model="password['retype']" class="form-control" @keydown.enter="updatePassword">
          </div>
          <div class="col-lg-12">
            <button class="btn-primary btn btn-xs" @click="updatePassword">Save</button>
          </div>
        </div>
      </div>
    </e-modal>
    <div v-if="eUser">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <button class="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target="#change-password">Change Password</button>
          <h3>{{ eUser.name }}</h3>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Name</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="eUser.name"
                      @input="updateProperty($event, 'name')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Username</td>
                  <td>
                    {{ eUser.username }}
                  </td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="eUser.email"
                      @input="updateProperty($event, 'email')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr  v-if="eUser.admin">
                  <td>Groups</td>
                  <td>
                    <v-select
                      multiple
                      :options="f.groups"
                      v-model="eUser.groups"
                      label="name"
                      @input="updateProperty($event.map(g => g.id), 'groups')"
                    >
                    </v-select>
                  </td>
                </tr>
                <tr v-if="eUser.admin">
                  <td>Active</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="eUser.active"
                      :selectedValue="eUser.active ? 'true' : 'false'"
                      :options="[{val: 'false', label: 'No'}, {val: 'true', label: 'Yes'}]"
                      selectLabel="label"
                      selectValue="val"
                      @input="selectProperty($event === 'true' ? 1 : 0, 'active')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '@/components/Helpers/Form/EditText'
import axios from 'axios'
import Form from '@/components/Helpers/Modal/Form'

export default {
  data () {
    return {
      eUser: {},
      password: {}
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser',
      userRoles: 'getUserRoles'
    })
  },
  components: {
    eTxt: EditText,
    eModal: Form
  },
  mounted () {
    this.getUser()
  },
  methods: {
    async getUser () {
      try {
        const res = await axios.get(`/v2/instalinko/webmasters/${this.$route.params.id}`)
        console.log(res.data)
        this.eUser = res.data
      } catch (err) {
        this.$toastr.error(err, 'Unable to get user')
      }
    },
    selectProperty (val, prop) {
      val ? this.updateProperty(!!val, prop) : this.deleteProperty()
    },
    async deleteProperty () {
      try {
        const res = axios.delete(`/v2/instalinko/webmasters/${this.eUser.id}`)
        this.eUser = res.data
        this.$toastr.success(`User deleted successfully`, 'Good')
      } catch (err) {
        this.$toastr.error(err, 'Unable to delete')
      }
    },
    async updateProperty (val, prop) {
      let data = {}
      data[prop] = val
      try {
        const res = await axios.patch(`/v2/instalinko/webmasters/${this.eUser.id}`, data)
        this.eUser = res.data
        this.$toastr.success(`${prop} updated successfully`, 'Good')
        this.$forceUpdate()
      } catch (err) {
        this.$toastr.error(err, 'Unable to update')
      }
    },
    async updatePassword () {
      if (this.password.pass.length < 6) {
        this.$toastr.error('Please at least put some effort in it and make it at least 6 chars long. Ok? Thanks *sigh*', 'Password too short')
        return
      }
      if (this.password.pass !== this.password.retype) {
        this.$toastr.error('Passwords don\'t match', 'No can\'t do')
        return
      }

      try {
        await axios.patch(`/v2/instalinko/webmasters/${this.eUser.id}/password`, {
          password: this.password.pass,
          retype: this.password.retype
        })
        this.$toastr.success('Password changed successfully')
        $('#change-password').modal('hide')
        this.password = {}
      } catch (err) {
        this.$toastr.error(err, 'Unable to change password')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Webmaster.vue